import React, { useEffect } from 'react';
import { Grid, Button, makeStyles } from '@material-ui/core';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import WorkstationTile from '../../Workstation/WorkstationTile';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';

export default function WorkstationOverviewPage(props) {

    const classes = useStyles();
    const [activeWorkstationIds, setActiveWorkstationIds] = useState([])
    let history = useHistory()

    useEffect(() => {
        let workstationIds = []
        var i;
        for (i = 0; i < props.workstation.activeWorkstations.length; i++) {
            workstationIds.push(props.workstation.activeWorkstations[i].id)
        }
        setActiveWorkstationIds(workstationIds)
    }, [props.workstation.activeWorkstations]);

    function activateWorkstation(workstationId) {
        let tempActiveWorkstations = Object.assign([], activeWorkstationIds);
        if (tempActiveWorkstations.some(x => x === workstationId)) {
            let index = tempActiveWorkstations.indexOf(tempActiveWorkstations.find(x => x === workstationId))
            tempActiveWorkstations.splice(index, 1)
            setActiveWorkstationIds(tempActiveWorkstations)
        }
        else {
            tempActiveWorkstations.push(workstationId)
            setActiveWorkstationIds(tempActiveWorkstations)
        }
    }

    function startProduction() {
        let activeWorkstations = props.workstation.workstations.filter(x => activeWorkstationIds.some(y => y === x.id))
        const min = Math.min(...activeWorkstationIds)
        props.actions.setSelectedWorkstation(min)
        props.actions.setActiveWorkstations(activeWorkstations)
        history.push("/workstation")
    }

    return (
        <div className={classes.background}>
            <div className={classes.spacer80}>
                Workstations
            </div>
            <Grid container spacing={2} className={classes.gridContainer}>
                {props.workstation.workstations ?
                    props.workstation.workstations.map((workstation) => (
                        <Grid className={classes.gridmargin} key={workstation.id} item>
                            {/* <NavLink className={classes.navButton} to={`/workstation/${encodeURIComponent(workstation.id)}/}`}> */}
                            <WorkstationTile workstation={workstation} orders={props.order.productionOrders.filter(x => x.workstation === workstation.id)} activateWorkstation={activateWorkstation} active={activeWorkstationIds.some(x => x === workstation.id)}></WorkstationTile>
                            {/* </NavLink> */}
                        </Grid>
                    )) : <React.Fragment></React.Fragment>}

            </Grid>
            <div className={classes.buttonContainer}>
                <Button className={classes.startProductionButton} onClick={startProduction}>SHOW PLANNING</Button>
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    spacer80: {
        height: '80px',
        color: "#000000",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        paddingLeft: "20px"
    },
    gridmargin: {

    },
    gridContainer: {
        maxWidth: "100%",
        paddingRight: "12%",
        paddingLeft: "12%"
    },
    navButton: {
        textDecoration: 'none'
    },
    background: {
        width: '100%',
        position: "relative",
        top: "60px",
    },
    startProductionButton: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        width: "200px",
        height: "40px",
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        "&:hover": {
            background: FlagstoneTheme.palette.primary.main
        },
    },
    buttonContainer: {
        width: "100%",
        textAlign: "center",
        marginTop: "50px"
    }
});